import {
  Localizations
} from 'localize'

Localizations.append({
  modules: {
    cart: {
      components: {
        cartItem: {
          remove: 'Remove from cart',
          stockWarning: 'Only {0} items in stock',
          pickup: 'Pick up',
          shipping: 'Ship it',
          choose: 'Choose:',
          pickupOnly: 'Available for pickup only'
        }
      }
    }
  }
})
